import { Component, OnInit } from '@angular/core';
import { DataStateEnum } from 'src/app/enumeration/dataState.enum';
import { Bien } from 'src/app/models/Bien';
import { Programme } from 'src/app/models/Programme';
import { Publication } from 'src/app/models/Publication';
import { OpeService } from 'src/app/services/ope/ope.service';
import { biTypologieDto } from 'src/app/models/biTypologieDto';
import { opeFgDto } from 'src/app/models/opeFgDto';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { Ope } from 'src/app/models/Ope';
import { SearchOpeCriteria } from 'src/app/models/SearchOpeCriteria';
import { OpeDetail } from 'src/app/models/OpeDetail';
import { vignetteOpe } from 'src/app/models/vignetteOpe';
import { BienService } from 'src/app/services/bi/bi.service';
import { opePublication } from 'src/app/services/PublicationOpe/opePublication.service';
import { LotBynumOpe } from 'src/app/models/LotBynumOpe';
import { DocServices } from 'src/app/services/docs/docs.services';
import { MapSingleComponent } from 'src/app/global-composants/map-single/map-single.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-programme-presentation',
  templateUrl: './programme-presentation.component.html',
  imports: [MapSingleComponent,CommonModule],
  styleUrls: ['./programme-presentation.component.scss']
})
export class ProgrammePresentationComponent implements OnInit {

  publication!: Publication[];
  programme!: Programme;
  prixstart!: number;
  readonly DataStateEnum = DataStateEnum;
  listebien: Bien[] = [];
  lisprix!: number[];
  prixlist!: number;
  count!: number;
  textpublication = '';
  pageSize = 1;
  pageIndex = 0;
  criteriaSearch: SearchOpeCriteria;
  nbmoisLivraison: number[] = [12];
  programmeseled!: Ope;
  nbpiece: number[] = [2, 4];
  myfirestlist!: Programme[];
  typeAbrgd!: biTypologieDto[];
  statut!: string[];
  minNo!: string;
  maxNo!: string;
  descriptionStatut!: string;
  dateprevLivraison!: opeFgDto;
  datepre!: string;
  quarter!: number;
  yearpre!: string;
  listOpe!: Programme[];
  prixtodisplay!: string;
  opedetail!: OpeDetail;
  datafrom!: OpeDetail;
  moispre!: string;
  jourspre!: string;
  date!: string;
  minTypeLot!: string;
  maxTypeLot!: string;
  vignettedetails!: vignetteOpe;
  urlImageVig = '';
  NewListLot: LotBynumOpe[] = [];
  loading!: boolean;
  imageLoaded = false;

  constructor(
    public share: shareOpeSevices, private readonly opeservice: OpeService, private bipub: opePublication, private biservice: BienService, private readonly docsndVigneteService: DocServices) {
    this.criteriaSearch = new SearchOpeCriteria();
  }

  ngOnInit() {

    //chargement des publications à afficher pour le ope X
    //bouchon de recheche : setter les critere de rech dans criteriaSearch  SearchOpeBiCriteria
    // this.criteriaSearch.nbrPieces = this.nbpiece;
    // this.criteriaSearch.nbmoisLivraison = this.nbmoisLivraison;
    this.share.vignetteDetails$.subscribe(res => {
      this.vignettedetails = res;
      this.urlImageVig = this.vignettedetails.url;

    })

    this.share.searchcrit$.subscribe(critere => {
      this.criteriaSearch = critere
    });
    this.share.datasOpe$.subscribe(data => this.programmeseled = data);
    this.dateprevLivraison = this.programmeseled.dateLivraison;
    this.moispre = this.dateprevLivraison.substring(5, 7);
    this.yearpre = this.dateprevLivraison.substring(0, 4);
    this.datepre = this.moispre;
    this.quarter = this.getQuarter();
    this.minTypeLot = this.programmeseled.minTypeLot;
    this.maxTypeLot = this.programmeseled.maxTypeLot;
    this.changeDescription();
    this.count = this.programmeseled.disponibles;
    this.prixlist = this.programmeseled.prixMin;
    this.prixtodisplay = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(Math.round(this.prixlist));
    this.getDataBienetPUB(this.programmeseled.numOpe, this.criteriaSearch);
    this.share.sendSelectedOpee(this.programmeseled);
    this.getUrlVignette_img(this.programmeseled.numOpe);
  }

  getDataBienetPUB(numOpe: number, criteriaSearch: SearchOpeCriteria) {

    // retrieve le programme  selectionné  depuis l'observalbe : s'abonner pour retrieve

    // this.opeservice.getOpeDetail(numOpe, criteriaSearch).subscribe((element: OpeDetail) => {
    //   this.datafrom = element;
    //   this.listebien = [...this.datafrom.biprincipalDtos.content];
    //   this.publication = [...this.datafrom.opePublDtos];
    //   //filter sur la langue Fr pour le moment
    //   this.publication=this.publication.filter(entry => entry.langue = 'FR');
    //   //sorted by numlinge
    //   this.publication = this.sortArraybyObjValue(this.publication, 'numLigne');
    //   this.publication.forEach(data => {
    //     this.textpublication += data.libelle;
    //   })

    //   // Attetnion pour chaque liste et tableau de date 
    //   // faudrait declarer un obserbable et s'abonner à celui ci 
    //   this.share.sendDatanew(this.listebien);

    // })

    this.bipub.getPublicationOpe(numOpe).subscribe(data => {

      this.publication = data;
      //filter sur la langue Fr pour le moment
      this.publication = this.publication.filter(entry => entry.langue = 'FR');
      //sorted by numlinge
      this.publication = this.sortArraybyObjValue(this.publication, 'numLigne');
      this.publication.forEach(data => {
        this.textpublication += data.libelle;
      })
    })

  }
  getLotsbynumOpe(numOpe: number, filtre: SearchOpeCriteria) {
    this.biservice.getListBienbynumOpe(numOpe, filtre).subscribe((data: any) => {
      this.NewListLot = data.content;

    }
    )
    this.share.sendDatanew(this.NewListLot);
  }


  // supprimer les duplications des publications via un param 
  //we will move this to package utils
  removeDuplicates(myArray: any[], Prop: string) {

    return myArray.filter((obj: any, pos: number, arr: any[]) => {
      return arr.map((mapObj: any) => mapObj[Prop as keyof typeof mapObj]).indexOf(obj[Prop as keyof typeof obj]) === pos;
    });
  }

  sortArraybyObjValue = (arr: any[], value: string | number) => {
    //return an array with object sorted by value 
    //sort by object key that matches the value 
    //we will move this to package utils
    return arr.sort((a, b) => {
      return a[value] - b[value];
      //return a[value] < b[value] ? -1 : a[value] > b[value] ? 1: 0
    })
  }

  getQuarter() {

    if (this.datepre === '01' || this.datepre === '02' || this.datepre === '03') {
      return 1
    }
    else if (this.datepre === '04' || this.datepre === '05' || this.datepre === '06') {
      return 2
    }
    else if (this.datepre === '07' || this.datepre === '08' || this.datepre === '09') {
      return 3
    }
    else {
      return 4
    }
  }

  changeDescription() {

    if (this.minTypeLot === this.maxTypeLot) {
      return this.descriptionStatut = "Du " + this.minTypeLot;
    }
    else {
      return this.descriptionStatut = `du ${this.minTypeLot} au ${this.maxTypeLot}`;
    }
  }
  // move to package util
  removeNull(array: any[]) {
    array.forEach((v, i) => {
      if (v == '0' || v == null) {
        array.shift();
      } else {
        array.splice(v - 1, 1);
      }
    })
  }

  getUrlVignette_img(data: number) {

    this.docsndVigneteService.getFirVignetteBynumOpe(data).subscribe(res => {
      this.urlImageVig = res.url;
    })

  }

}


